import type { ReactNode } from 'react';

import styles from './Badge.module.css';

type BadgeTone = 'neutral' | 'info' | 'ok' | 'warn' | 'crit';
type BadgeSize = 'xs' | 'sm' | 'md';

export interface BadgeProps {
  tone?: BadgeTone;
  size?: BadgeSize;
  children: ReactNode;
}

/**
 * MCUI Badge — mirror from broadcast-frontend atoms.
 * Inline status label with semantic tones.
 */
export function Badge({ tone = 'neutral', size = 'sm', children }: BadgeProps) {
  return (
    <span className={`${styles.root} ${styles[`tone-${tone}`]} ${styles[`size-${size}`]}`}>
      {children}
    </span>
  );
}
